import './Table.scss';
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Checkbox, FontIcon } from 'react-md';
import { TableActionBar, ThItem, NoTableData } from '../index';
import { connect } from 'react-redux';
import { idFormatter } from '../../utils';
import TableMenu from '../TableMenu/TableMenu';

class TableComponent extends Component {
  state = {
    data: [],
    activeSortKey: '',
    activeSortDirection: '',
    loadMore: false,
    filteredOrgsMatch: false,
    selectedOrgKeys: [],
    selectedLots: [],
    selectAll: false,
    filteredData: false,
    hoverItem: ''
  }

  componentDidMount = () => {
    const newData = this.props.data;
    if (newData) {
      this.setState({ data: newData });
    }
  }

  componentDidUpdate = (prevProps) => {
    const { filteredData, title, data } = this.props;
    if (this.props !== prevProps) {
      this.setState({ data: data });
    }
    // filtering and unfiltering data will deselect any currently selected lots
    if (title === 'Lots/Garages' && !filteredData && filteredData !== prevProps.filteredData) {
      this.setState({
        filteredOrgsMatch: false,
        selectedOrgKeys: [],
        selectedLots: [],
        selectAll: false
      });
    }
    // further filtered data deletes selected lots but keeps selectedOrgKeys to compare against
    if (title === 'Lots/Garages' && filteredData && data !== prevProps.data) {
      this.setState({
        selectedLots: [],
        selectAll: false
      });
    }
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  formatData(key, value) {
    if (key.includes('role')) {
      return value.relationships ? value.relationships[0].relationshipType && value.relationships[0].relationshipType.toLowerCase() : 'Undefined';
    } else if (key.includes('organization')) {
      if (this.props.title === 'Lots/Garages') {
        return value.organizations && value.organizations.map(x => x.displayName);
      } else if (this.props.title === 'People' || this.props.title === 'sendEmail') {
        return value.relationships ? value.relationships.filter(x => x.fromPartyKey).map(x => x.displayName) : 'Undefined';
      }
    } else if (key.includes('relationshipType')) {
      let relation = value.relationshipType && value.relationshipType.split('_').join(' ').toLowerCase();
      return relation;
    } else if (key.includes('displayName')) {
      return value[key];
    } else if (key.includes('registered')) {
      return value[key] ? 'Yes' : 'No';
    } else if (key.includes('invites')) {
      return value[key] > 0 ? `Yes` : 'No';
    } else {
      return value[key] ? value[key] : null;
    }
  }

  resetSort = () => {
    this.setState({
      activeSortKey: '',
      activeSortDirection: ''
    });
  }

  resetLotInput = () => {
    this.setState({
      selectAll: false,
      selectedLots: [],
      selectedOrgKeys: []
    });
  }

  sortData = (key, direction = 'asc', sortable) => {
    if (sortable) {
      this.setState((state, props) => {
        return {
          activeSortDirection: direction,
          activeSortKey: key,
          data: _.orderBy(props.data, [x => x[key] && x[key].toString().toLowerCase()], direction)
        };
      });
    }
  }

  // compares the items organizations partyKeys to the current lotOrg
  compareOrgKeys = (item) => {
    const { selectedOrgKeys } = this.state;

    if (selectedOrgKeys.length > 0) {
      const orgKey = item.organizations.map(org => org.partyKey);
      const stateOrgKeys = selectedOrgKeys.map(org => org.partyKey);
      return _.isEqual(orgKey.sort(), stateOrgKeys.sort());
    }
    return false;
  }

  handleSelectAll = (value) => {
    const { filteredData, data } = this.props;
    const { filteredOrgsMatch } = this.state;
    if ((!value) && ((!filteredData) || (filteredData && !filteredOrgsMatch))) {
      // if deselecting without filtered data
      // if deselecting with filtered data but no filtered orgs to not match
      this.setState({
        selectedLots: [],
        selectedOrgKeys: []
      });
    } else if (!value && filteredData && filteredOrgsMatch) {
      // if filtered orgs all match and we deselect all this will leave org key to compare
      this.setState({
        selectedLots: []
      });
    } else {
      // select all
      const matches = data.filter(d => this.compareOrgKeys(d));
      this.setState({ selectedLots: matches });
    }
    this.setState({ selectAll: value });
  }

  checkboxOnChangeHandler = (value, item) => {
    const { selectedLots, filteredOrgsMatch } = this.state;
    const { filteredData } = this.props;

    if (value) {
      this.setState({
        selectedLots: selectedLots.concat(item),
        selectedOrgKeys: item.organizations
      });
    } else {
      const updateLotsSelection = selectedLots.filter(val => val.externalKey !== item.externalKey);
      this.setState({
        selectedLots: updateLotsSelection,
        selectAll: value
      });
      if ((updateLotsSelection.length < 1 && !filteredData) || (updateLotsSelection.length < 1 && filteredData && !filteredOrgsMatch)) {
        this.setState({ selectedOrgKeys: [] });
      }
    }

    if (!value && selectedLots.length < 1) {
      this.setState({ selectAll: value });
    }
  }

  isChecked = (value) => {
    return this.state.selectedLots.find(item => item.externalKey === value.externalKey);
  }

  hoverHandler = (e, item) => {
    if (e.type === 'mouseenter') {
      this.setState({ hoverItem: item });
    } else if (e.type === 'mouseleave') {
      this.setState({ hoverItem: '' });
    }
  }

  // checks if all returned data is matching
  setOrgsByFilter = (orgs, matched) => {
    this.setState({
      selectedOrgKeys: orgs,
      filteredOrgsMatch: matched
    });
  }

  render() {
    const { labelKeys, title, actions, filteredData } = this.props;
    const { activeSortKey, loadMore, selectedLots, selectAll, selectedOrgKeys, hoverItem } = this.state;
    const dataStyle = (data) => data.status === 'failed' ? 'rgba(239, 83, 80, 0.2)' : data.status === 'pending' && 'rgba(253, 216, 53, 0.2)';
    const data = this.state.data && this.state.data.length > 0 ? this.state.data : this.props.data;
    const tableData = loadMore ? data : data.slice(0, 50);

    return (
      <div className="ph-table">
        <TableActionBar title={title} show={actions.show} data={data} resetSort={this.resetSort} setOrgs={this.setOrgsByFilter} />
        <table>
          <thead >
            <tr>
              {labelKeys && labelKeys.map((lk, index) => (
                <th
                  className={
                    lk.label === 'multiLotEdit' && (selectAll || selectedLots.length > 0) ? 'th-edit-menu display-menu' :
                      lk.label === 'multiLotEdit' && lk.sortable === false ? 'th-edit-menu' :
                        lk.label === 'checkbox' && lk.sortable === false ? 'checkbox-th' :
                          lk.sortable === false ? 'disabled-sort' :
                            ''
                  }
                  key={index}
                >
                  <ThItem
                    id={`table-head-${idFormatter(lk.key)}-sort`}
                    activeSortKey={activeSortKey}
                    sortKey={lk.sortable && lk.key}
                    sortable={lk.sortable}
                    onClick={this.sortData}
                  >
                    { lk.label === 'checkbox' ?
                      (
                        <Checkbox
                          name='lot-select'
                          aria-label='lot-select'
                          id='selectAll'
                          className='th-checkbox'
                          disabled={selectedOrgKeys.length === 0}
                          checkedCheckboxIcon={<FontIcon>indeterminate_check_box</FontIcon>}
                          onChange={(v) => this.handleSelectAll(v, filteredData)}
                          checked={selectAll && selectedLots.length > 0 ? true : selectAll && selectedLots.length < 1 ? false : false}
                        />
                      ) : (lk.label === 'multiLotEdit' && selectedLots.length > 0) ?
                        (
                          <TableMenu
                            resetSort={this.resetSort}
                            actions={actions}
                            item={selectedLots}
                            title={title}
                            index={1}
                            resetLotInput={this.resetLotInput}
                          />
                        ) : lk.label !== 'multiLotEdit' && ( lk.label )
                    }
                  </ThItem>
                </th>
              ))}
              { title !== 'Lots/Garages' && <th /> }
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.map((item, index) => {
              const disabledCheckbox = selectedLots.length > 0 && !this.compareOrgKeys(item);
              const inactive = new Date(item.deactivation) < new Date();
              return (
                <tr
                  onMouseEnter={(e) => this.hoverHandler(e, item.externalKey)}
                  onMouseLeave={(e) => this.hoverHandler(e, item.externalKey)}
                  id={`table-row-${index}`}
                  style={{ backgroundColor: dataStyle(item) }}
                  key={index}
                  className={
                    title === 'Lots/Garages' && this.isChecked(item) ? 'checked' :
                      title === 'People' && inactive ? 'deactivated' :
                        ''
                  }
                >
                  {labelKeys.map((lk, keyIndex) => {
                    return (
                      <td
                        key={keyIndex}
                        title={_.isArray(this.formatData(lk.key, item)) ? this.formatData(lk.key, item) : ''}
                        className={
                          (lk.key === 'role' || lk.key === 'relationshipType') ? 'role' :
                            title === 'Lots/Garages' ? `lot-${lk.key}` :
                              ''
                        }
                        style={{ width:
                          title === 'People' ? `${(1 / 6) * 100}%` :
                            title === 'Organizations' ? `${(1 / 4) * 100}%` :
                              ''
                        }}
                      >
                        {inactive && lk.label === 'Name' ? item.displayName :
                          inactive ? '' :
                            _.isArray(this.formatData(lk.key, item)) ?
                              (this.formatData(lk.key, item).length <= 2 ?
                                this.formatData(lk.key, item).join(', ') :
                                <span>
                                  {
                                    this.formatData(lk.key, item).slice(0, 2).join(', ') +
                          `, & ${this.formatData(lk.key, item).length - 2} ${this.formatData(lk.key, item).length - 2 <= 1 ? 'other' : 'others'}`
                                  }
                                </span>
                              ) : (
                                lk.key === 'checkbox' ? (
                                  <Checkbox
                                    name='lot-select'
                                    aria-label='lot-select'
                                    disabled={disabledCheckbox}
                                    className={disabledCheckbox ? 'disabled' : ''}
                                    id={item.displayName}
                                    checked={this.isChecked(item) ? true : selectAll && this.compareOrgKeys(item) ? true : false}
                                    key={index}
                                    onChange={(v) => this.checkboxOnChangeHandler(v, item)}
                                  />
                                ) : ((lk.key === 'multiLotEdit' && hoverItem === item.externalKey && selectedLots.length < 1 && !selectAll) ?
                                  <TableMenu
                                    resetSort={this.resetSort}
                                    className='tb-table-menu'
                                    actions={actions}
                                    item={title === 'Lots/Garages' ? [item] : item}
                                    title={title}
                                    index={index}
                                    resetLotInput={this.resetLotInput}
                                  /> : item[lk.key])
                              )}
                      </td>
                    );
                  })}
                  {title !== 'Lots/Garages' &&
                    <td
                      className="table-edit-button"
                    >
                      <TableMenu
                        resetSort={this.resetSort}
                        actions={actions}
                        item={title === 'Lots/Garages' ? [item] : item}
                        title={title}
                        index={index}
                      />
                    </td>
                  }
                </tr>
              );
            })}
          </tbody>
        </table>
        {data.length <= 0 && !this.props.isLoading && <NoTableData />}
        {data.length > 0 && tableData.length < data.length && <Button className="load-more-button" flat onClick={() => this.setState({ loadMore: true })}>load more</Button>}
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, {
})(TableComponent);



// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx